import { CircularProgress } from '@mui/material';
import React from 'react'
import { Link, useParams } from 'react-router-dom'
import img from '../pages/property/submit-property.png'

const PaymentStatusPage = () => {
    const { page } = useParams()
    return (
        <>
            {
                page ?
                    <div className='card-body card min-vh-75'>
                        {/* Begin:: Vitta logo */}
                        <img
                            alt='Logo'
                            src='/media/logos/favicon2.jpg'
                            className='h-100px mx-auto d-block mt-2'
                        ></img>
                        {/* End:: Vitta logo */}
                        <div data-kt-stepper-element='content'>
                            <div className='w-100 text-center'>
                                {/* begin::Illustration */}
                                <div className='text-center'>
                                    <img src={img} alt='img' className='mw-100 mh-200px' />
                                </div>
                                {/* end::Illustration */}
                                {/* begin::Heading */}
                                <h1 className='fw-bold text-dark mb-3'>Payment processing!</h1>
                                {/* end::Heading */}
                                {/* begin::Description */}
                                <div className='text-muted fw-semibold fs-3'>
                                    It might take few minutes
                                </div>
                                {/* end::Description */}
                                <Link to={page === "rent" ? `/rented-properties/${localStorage.getItem('tenant_rent_uuid')}` : "lead_booking_payment" ? "/lead_management/lead-dashboard" : "#"}
                                    onClick={() => page === "rent" && localStorage.removeItem('tenant_rent_uuid')}
                                    className='btn btn-primary mt-8'>
                                    Back
                                </Link>
                            </div>
                        </div>
                    </div>
                    :
                    // {* Begin: loader*}
                    <div
                        className='d-flex justify-content-center align-items-center vh-70'
                        style={{ height: '100vh' }}
                    >
                        <CircularProgress />
                    </div>
                // {* End: loader*}
            }
        </>
    )
}

export default PaymentStatusPage